import CONSTANTS from "./constants";

const apiEndPoints = {
  [CONSTANTS.TABBAR_TAB_LIST_GET]: {
    url: ({ courseId }) => `/v2/course/courseTabList/${courseId}`,
    method: "GET",
  },
  [CONSTANTS.GET_COURSE_COUPON_STUDENT_OVERVIEW]: {
    url: () => "/cams/store/priceBreakup",
    method: "POST",
  },
};

export default apiEndPoints;
